// @ts-nocheck
export default {
  DONORS_TABLE_STATE_SET: 'DONORS/TABLE_STATE_SET',
  DONORS_TABLE_STATE_RESET: 'DONORS/TABLE_STATE_RESET'
};
